import React from 'react';
import { cn } from '../../utils/cn';

export interface SectionItem {
  id: string;
  label: string;
}

export interface SectionNavigationProps {
  sections: SectionItem[];
  activeSection: string;
  onSectionClick: (id: string) => void;
}

const SectionNavigation: React.FC<SectionNavigationProps> = ({
  sections,
  activeSection,
  onSectionClick,
}) => {
  const handleClick = (id: string) => {
    onSectionClick(id);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className="sticky top-0 z-10 flex gap-1 overflow-x-auto bg-[var(--card)] border-b border-[var(--border)]"
      role="tablist"
      aria-label="Form sections"
    >
      {sections.map((section) => {
        const isActive = section.id === activeSection;
        return (
          <button
            key={section.id}
            role="tab"
            aria-selected={isActive}
            className={cn(
              'whitespace-nowrap px-4 py-3 text-sm font-medium transition-colors duration-150 border-b-2 bg-transparent cursor-pointer',
              isActive
                ? 'text-[var(--primary-600)] border-[var(--primary-500)]'
                : 'text-[var(--muted-foreground)] border-transparent hover:text-[var(--foreground)]'
            )}
            style={{ fontSize: '14px', fontWeight: 500 }}
            onClick={() => handleClick(section.id)}
          >
            {section.label}
          </button>
        );
      })}
    </nav>
  );
};

export default SectionNavigation;
